import Component from './component';

export default class Slider extends Component {
  constructor (props) {
    super(props);
    this.sliding = false;
    this.handleEvent = this.handleEvent.bind(this);

    Object.defineProperties(this, {
      value: {
        get () {
          return this.props.value;
        }
      },
      min: {
        get () {
          return this.props.min;
        }
      },
      max: {
        get () {
          return this.props.max;
        }
      },
      step: {
        get () {
          return this.props.step;
        }
      }
    });
  }

  getDefaultProps () {
    return {
      min: 0,
      max: 100,
      value: 0,
      step: 1,
      name: '',
      onchange: function () {}
    };
  }

  setProps (props) {
    Object.assign(this.props, props);
    this.updateWhileNotSliding();
  }

  handleEvent (event) {
    const pageKey = this.props.vertical ? 'pageY' : 'pageX';
    const offsetKey = this.props.vertical ? 'top' : 'left';
    const dimKey = this.props.vertical ? 'height' : 'width';

    if (this.$container && (event.type === 'mouseup' || event.type === 'mousemove' || event.type === 'touchmove')) {
      const page = event.type === 'touchmove' ? event.touches[0][pageKey] : event[pageKey];
      const bounds = this.$container.getBoundingClientRect();
      const offset = bounds[offsetKey];
      const dim = bounds[dimKey];
      let ratio = Math.max(0, Math.min(1, (page - offset) / dim));

      if (this.props.vertical) {
        ratio = 1 - ratio;
      }

      this.props.value = Math.max(
        this.props.min,
        Math.min(
          this.props.max,
          Math.round(ratio * (this.props.max - this.props.min) / this.props.step) * this.props.step
        )
      );

      this.update();
    }

    if (event.type === 'mouseup' || event.type === 'touchend') {
      this.sliding = false;

      if (event.type === 'mouseup') {
        document.removeEventListener('mousemove', this);
        document.removeEventListener('mouseup', this);
      } else if (this.$element) {
        this.$element.removeEventListener('touchmove', this);
        this.$element.removeEventListener('touchend', this);
      }

      // call the changed handler
      this.emit({ type: 'change' });
      if (typeof this.props.onchange === 'function') {
        this.props.onchange();
      }
    }

    if (event.type === 'mousedown' || event.type === 'touchstart') {
      event.preventDefault();

      this.sliding = true;

      if (event.type === 'mousedown') {
        document.addEventListener('mousemove', this);
        document.addEventListener('mouseup', this);
      } else if (this.$element) {
        this.$element.addEventListener('touchmove', this);
        this.$element.addEventListener('touchend', this);
      }
    }
  }

  attach (element) {
    super.attach(element);

    this.$container = this.$('.iono-slider-container');
    this.$knob = this.$('.iono-slider-knob');
    this.$progress = this.$('.iono-slider-progress');

    // GH slider requires a container element in order for click and drag handlers
    //  to function correctly, so don't even bother binding event listeners when
    //  this element is not present in the rendered slider.
    if (this.$container) {
      this.$element.addEventListener('mousedown', this);
      this.$element.addEventListener('touchstart', this);
    }

    this.update();
  }

  update () {
    if (!this.$element) return false;

    if (this.props.vertical) {
      this.$element.classList.add('iono-slider-vertical');
    } else {
      this.$element.classList.remove('iono-slider-vertical');
    }

    if (this.$knob) {
      this.$knob.setAttribute('aria-valuenow', this.props.value);
      this.$knob.setAttribute('aria-valuemax', this.props.max);
      this.$knob.setAttribute('aria-valuemin', this.props.min);
    }

    const percent = Math.min(100, Math.max(0, this.props.value / this.props.max * 100));
    const knobKey = this.props.vertical ? 'bottom' : 'left';
    const progressKey = this.props.vertical ? 'height' : 'width';

    if (this.$knob) this.$knob.style[knobKey] = `${percent}%`;
    this.$progress.style[progressKey] = `${percent}%`;
  }

  updateWhileNotSliding () {
    if (!this.sliding) this.update();
  }

  detach () {
    if (!this.$element) return false;

    this.$container = null;
    this.$knob = null;
    this.$progress = null;

    this.$element.removeEventListener('mousedown', this);
    this.$element.removeEventListener('touchstart', this);

    document.removeEventListener('mousemove', this);
    document.removeEventListener('mouseup', this);
    document.removeEventListener('touchmove', this);
    document.removeEventListener('touchend', this);

    super.detach();
  }

  render () {
    return `
    <div class="iono-slider">
      <div class="iono-slider-track"></div>
      <div class="iono-slider-progress"></div>
      <div class="iono-slider-container">
        <button role="slider" aria-label="${this.props.name}" aria-valuemin="${this.props.min}" aria-valuemax="${this.props.max}" aria-valuenow="${this.props.value}" class="iono-slider-knob"></button>
      </div>
    </div>
    `;
  }
}
